import { useContext } from 'react';
import { ToastContext } from 'contexts/ToastContext';

export function useToast() {
  const context = useContext(ToastContext);
  return { addToast: context.addToast, removeToast: context.remove };
}
